export const emptyMapping = () => ({
  primary_column: '', secondary_column: null, secondary_format: ''
});

export function suggestMapping(columns) {
  const normalized = column => column.name.toLowerCase().replace(/[^a-z0-9]/g, '');
  const internal = columns.find(column => /^(internal(part)?(number|no|pn)?|ipn|customerpartnumber|companypartnumber)$/.test(normalized(column)));
  const mpn = columns.find(column => /^(mpn|manufacturerpart(number|no)?|mfrpart(number|no)?)$/.test(normalized(column)));
  const primary = internal || mpn || columns.find(column => /^(part(number|no)?|pn)$/.test(normalized(column)));
  return { primary_column: primary?.id || '', secondary_column: null, secondary_format: '' };
}

export function validMapping(mapping, columns) {
  if (!mapping || !columns.some(column => column.id === mapping.primary_column)) return false;
  return mapping.secondary_column === null || (
    mapping.secondary_column !== mapping.primary_column
    && columns.some(column => column.id === mapping.secondary_column)
    && ['single', 'comma'].includes(mapping.secondary_format)
  );
}

export function mappedMPNs(row, mapping) {
  const value = String(row.data[mapping.secondary_column] ?? '');
  return (mapping.secondary_format === 'comma' ? value.split(',') : [value])
    .map(part => part.trim()).filter(Boolean);
}

// Only authorized source data is passed here. Source identities never change.
export function groupPartRows(rows, mapping, columns, originalRows = rows) {
  if (!mapping?.secondary_column) return rows;
  const originals = new Map(originalRows.map(row => [row.line_item_id, row]));
  const groups = new Map();
  rows.forEach(row => {
    const primary = String((originals.get(row.line_item_id) || row).data[mapping.primary_column] ?? '').trim();
    const key = primary ? `part:${primary}` : `blank:${row.line_item_id}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  });
  return [...groups.values()].map(sourceRows => {
    const first = sourceRows[0];
    const data = Object.fromEntries(columns.map(column => {
      const value = first.data[column.id] ?? '';
      return [column.id, sourceRows.every(row => (row.data[column.id] ?? '') === value)
        ? value : 'Varies — expand to view source lines'];
    }));
    data[mapping.primary_column] = String((originals.get(first.line_item_id) || first).data[mapping.primary_column] ?? '').trim();
    return { ...first, data, sourceRows };
  });
}
